import { render, staticRenderFns } from "./ElementoForm.vue?vue&type=template&id=2925705e&scoped=true&"
import script from "./ElementoForm.vue?vue&type=script&lang=js&"
export * from "./ElementoForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2925705e",
  null
  
)

export default component.exports